/* Ohana free pack - email capture.
 * DO NOT ADD fbq() CALLS. window.fbq does not exist on this storefront: the Meta pixel
 * loads inside Shopify's sandboxed web-pixels-manager and is never exposed globally.
 * Verified 2026-08-07. The thank-you URL IS the conversion - only submitters reach it,
 * Shopify's own pixel fires a real PageView there and Meta matches on the URL.
 */
(function () {
  var KLAVIYO_COMPANY_ID = 'TL4skQ';
  var KLAVIYO_LIST_ID = 'WarCnG';
  var KLAVIYO_REVISION = '2024-10-15';

  function init(root) {
    if (root.dataset.ohanaInit === '1') { return; }
    root.dataset.ohanaInit = '1';

    var form = root.querySelector('[data-ohana-form]');
    var input = root.querySelector('[data-ohana-email]');
    var hp = root.querySelector('[data-ohana-hp]');
    var btn = root.querySelector('[data-ohana-submit]');
    var btnLabel = root.querySelector('[data-ohana-btn-label]');
    var errorEl = root.querySelector('[data-ohana-error]');
    var next = root.getAttribute('data-ohana-next') || '/pages/ohana-thank-you';
    var source = root.getAttribute('data-ohana-source') || 'Ohana free page';
    if (!form) { return; }

    function valid(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e); }
    function go() { window.location.assign(next); }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      errorEl.textContent = '';
      errorEl.hidden = true;

      if (hp && hp.value) { go(); return; }

      var email = (input.value || '').trim();
      if (!valid(email)) {
        errorEl.textContent = 'That email address does not look right. Mind checking it?';
        errorEl.hidden = false;
        input.focus();
        return;
      }

      btn.disabled = true;
      btnLabel.textContent = 'Sending...';

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email, properties: { 'Signup Source': source } } } }
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': KLAVIYO_REVISION },
        body: JSON.stringify(payload),
        keepalive: true
      }).then(function (res) {
        if (!(res.status === 202 || res.ok) && window.console) { console.warn('[ohana] subscribe status', res.status); }
        go();
      }).catch(function (err) {
        if (window.console) { console.warn('[ohana] subscribe failed:', err); }
        go();
      });
    });
  }

  function boot() {
    var roots = document.querySelectorAll('.ohana-lp[data-ohana-mode="capture"]');
    for (var i = 0; i < roots.length; i++) { init(roots[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
